import React, {useContext, useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { Col, Container, Row, Button, Offcanvas } from "react-bootstrap";
import { FilterCircle } from "react-bootstrap-icons";
import { useMediaQuery } from 'react-responsive';
import {observer} from "mobx-react-lite";
import {Context} from "../..";

import Filter from '../Filter';
import ProductList from "../ProductList";
import '../FrontProductsBlock.css';
import './catpanel.css';
import Pagination from "./Pagination/Pagination";
import LoadMoreButton from "./Pagination/LoadMoreButton";
import { useProductsLoader } from "../../hooks/useProductsLoader";
import { useFiltersLoader } from "../../hooks/useFiltersLoader";


const SubCatalogList = observer(({ categories }) => {
  const { user, product } = useContext(Context);
  const [searchParams] = useSearchParams();
  const [filtersFromURLLoaded, setFiltersFromURLLoaded] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  
  const isMobile = useMediaQuery({ maxWidth: 600 });

  // 1. Парсим фильтры из URL
  useEffect(() => {
      const filtersFromURL = {};
      //    console.log ("product.pagination.page:",product.pagination.page,"           product.pagination.pageSize:",product.pagination.pageSize)
      for (const [key, value] of searchParams.entries()) {
        if (key.includes('[')) {
          const match = key.match(/^(.+?)\[(from|to)\]$/);
          if (match) {
            const [, name, field] = match;
            filtersFromURL[name] = {
              ...(filtersFromURL[name] || {}),
              [field]: value,
            };
          }
        } else if (key.endsWith('[]')) {
          const name = key.slice(0, -2);
          filtersFromURL[name] = [...(filtersFromURL[name] || []), value];
        } else {
          filtersFromURL[key] = [value];
        }
      }
    
      if (Object.keys(filtersFromURL).length > 0) {
        product.setSelectedFilters(filtersFromURL);
      }
      // важное!
      setFiltersFromURLLoaded(true);
  }, []);

/*
  // 2. Загружаем продукты, только когда URL фильтры применены
  useEffect(() => {
      if (!filtersFromURLLoaded) return;
      const selectedFolderFilters = product.requestBodyFilter;
      getProducts(product.selectedFolder.id, product.pagination.page, product.pagination.pageSize, selectedFolderFilters)
        .then(data => {          
            product.setProducts(data.products);
            product.setFilters(data.filters);
            product.setPagination({
               page: data.page,        // если бек возвращает с 0, а у тебя page с 1
               pageCount: data.pageCount,
               pageSize: data.pageSize
            });
             if (user.viewAsManager) {
        const productIds = data.products.map((p) => p.id);

        // import { getProducts, getWholesalePrices } from "../../http/productAPI";  
        // const { user, product } = useContext(Context);
 try {
          getWholesalePrices(productIds)
            .then(optPrices  => { 
          // 💡 Например, сохраним отдельно
          // product.setWholesalePrices(wholesalePrices);
          // или обновим продукты с оптовыми ценами
           product.setProducts(
             data.products.map((p) => ({
               ...p,
               optPrice: optPrices.find((w) => w.id === p.id)?.optPrice,
             })
            )
           )});
        } catch (err) {
          console.error("Ошибка при получении оптовых цен:", err);
        }
      }
    })
    .catch((error) => {
      console.error("Ошибка при получении продуктов:", error);
    });
}, [
      filtersFromURLLoaded,
      product.search,
      product.selectedFolder,
      product.selectedFilters,
      product.reload,
      user.viewAsManager
  ]);
*/

  useProductsLoader(filtersFromURLLoaded);
  useFiltersLoader(filtersFromURLLoaded);

  return (
    <Container className="mb-5">
      <Row>
        {!isMobile && (
          <Col xs={2} className="filter-sidebar">
            <Filter selectedFolderFilters={product.selectedFolderFilters} />
          </Col>
        )}

        <Col xs={12} md={10} className="px-0">
          {isMobile && (
            <div className="mobile-filters-button-wrapper">
              <Button variant="secondary" className="mobile-filters-button" onClick={() => setShowFilters(!showFilters)}>
                <FilterCircle className="me-2" size={24}/>
                {showFilters ? 'Применить фильтры' : 'Показать фильтры'}
              </Button>
            </div>
          )}

          
            <ProductList />
          

         {/*  {product.pagination.pageCount > 1 && <LoadMoreButton />}*/}
          {product.pagination.pageCount > 1 && <Pagination />}

        </Col>
      </Row>

      {/* Мобильное отображение фильтров */}
      <Offcanvas show={showFilters} onHide={() => setShowFilters(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Фильтры</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Filter selectedFolderFilters={product.selectedFolderFilters} />
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
});

export default SubCatalogList;